$component: 'zr-add-to-cart-count';

vx-add-to-cart-count {
    display: block;
    margin: 0 0 0 auto;
    max-width: max-content;
}
